import React from 'react'
import { useParams } from 'react-router'
import { useDistrict } from '../../hooks/CompanyConfiguration/useDistrict'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import DistrictView from '../../components/version-4/viewForms/DistrictView'
import { ROUTES } from '../../shared/constants'

function ViewDistrict() {
  const { district, getDistrict } = useDistrict()
  const params = useParams()

  React.useEffect(() => {
    getDistrict({ districtId: params.districtId })
  }, [params.districtId])

  return (
    <Layout heading="District" heading2="Info" url1={ROUTES.DISTRICT} none>
      {district ? (
        <HeaderTabLayout
          heading="District"
          content={<DistrictView district={district} />}
          view
          url={`/edit-district/${params.districtId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewDistrict
